export default __webpack_public_path__ + "dfc3e1f1b6ed9ef0c6f8898e5ce86226.png";